export const LOCAL_STORAGE_TEMPLATE_SELECTED = "_templateSelected"